<template>
  <div class="home">
    <!-- 英雄区域 -->
    <section class="hero">
      <div class="hero-container">
        <div class="hero-image hero-image-1"></div>
        <div class="hero-image hero-image-2"></div>
        <div class="hero-mask"></div>
          <div class="hero-overlay"></div>
        <div class="container">
          <div class="hero-content">
            <h1 class="hero-title">
              <span v-for="(char, index) in titleText.split('')" :key="'title-' + index">{{ char }}</span>
            </h1>
            <p class="hero-subtitle">
              <span v-for="(char, index) in subtitleText.split('')" :key="'subtitle-' + index">{{ char }}</span>
            </p>

          </div>
        </div>
      </div>
    </section>

    <!-- 特性区域 -->
    <section class="features">
      <div class="container">
        <h2>我们的优势</h2>
        <div class="feature-cards">
          <div class="feature-card">
            <div class="icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>专业团队</h3>
            <p>我们拥有一支经验丰富的专业团队，为您提供最优质的服务</p>
          </div>
          <div class="feature-card">
            <div class="icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 17L12 13L15 17" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 13V7" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>创新技术</h3>
            <p>我们不断创新，采用最新技术为客户提供高效解决方案</p>
          </div>
          <div class="feature-card">
            <div class="icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M23 21V19C22.9993 18.1194 22.7172 17.265 22.1887 16.5637C21.6603 15.8624 20.9053 15.3606 20.03 15.11V8C20.03 6.12424 19.3441 4.31978 18.0711 2.92893C16.7981 1.53808 14.9937 0.75 13.12 0.75C11.2463 0.75 9.44186 1.53808 8.16882 2.92893C6.89578 4.31978 6.21 6.12424 6.21 8V13" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>客户至上</h3>
            <p>我们始终以客户需求为中心，提供个性化的解决方案</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 解决方案体系 -->
    <section class="solutions">
      <div class="container">
        <h2>解决方案体系</h2>
        <div class="solution-cards">
          <router-link to="/covs" class="solution-card">
            <div class="solution-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>VOCs综合管控</h3>
            <p>提供VOCs在线监测、政府/园区级VOCs综合管控、集团/企业级VOCs综合管控服务</p>
          </router-link>
          <router-link to="/ldar" class="solution-card">
            <div class="solution-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 17L12 13L15 17" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 13V7" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>LDAR检测</h3>
            <p>提供泄漏检测与修复服务，配备先进的检测设备和专业技术团队</p>
          </router-link>
          <router-link to="/environmental" class="solution-card">
            <div class="solution-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M23 21V19C22.9993 18.1194 22.7172 17.265 22.1887 16.5637C21.6603 15.8624 20.9053 15.3606 20.03 15.11V8C20.03 6.12424 19.3441 4.31978 18.0711 2.92893C16.7981 1.53808 14.9937 0.75 13.12 0.75C11.2463 0.75 9.44186 1.53808 8.16882 2.92893C6.89578 4.31978 6.21 6.12424 6.21 8V13" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>排污/环保管家</h3>
            <p>提供环保管家业务和排污许可管家业务，为企业和园区提供全方位环保服务</p>
          </router-link>
          <router-link to="/soil-remediation" class="solution-card">
            <div class="solution-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 8V16" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 12H16" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>场调/土壤修复</h3>
            <p>提供场地环境调查、风险评估和修复治理等污染场地修复的全过程技术咨询服务</p>
          </router-link>
        </div>
      </div>
    </section>

    <!-- 行业解决方案 -->
    <section class="industry-solutions">
      <div class="container">
        <h2>行业解决方案</h2>
        <div class="industry-cards">
          <div class="industry-card">
            <div class="industry-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 17L12 13L15 17" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 13V7" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>石油天然气</h3>
            <p>针对石油天然气行业的VOCs排放特点，提供定制化的监测与治理解决方案</p>
          </div>
          <div class="industry-card">
            <div class="industry-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>储运行业</h3>
            <p>为储运行业提供符合安全要求的VOCs治理和LDAR检测服务</p>
          </div>
          <div class="industry-card">
            <div class="industry-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M23 21V19C22.9993 18.1194 22.7172 17.265 22.1887 16.5637C21.6603 15.8624 20.9053 15.3606 20.03 15.11V8C20.03 6.12424 19.3441 4.31978 18.0711 2.92893C16.7981 1.53808 14.9937 0.75 13.12 0.75C11.2463 0.75 9.44186 1.53808 8.16882 2.92893C6.89578 4.31978 6.21 6.12424 6.21 8V13" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>煤化工行业</h3>
            <p>针对煤化工行业的高VOCs排放特点，提供高效的治理方案和监测服务</p>
          </div>
          <div class="industry-card">
            <div class="industry-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 8V16" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 12H16" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>精细化工</h3>
            <p>为精细化工企业提供符合环保要求的VOCs治理和监测解决方案</p>
          </div>
          <div class="industry-card">
            <div class="industry-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 7H16" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 11H16" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 15H16" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>印刷包装</h3>
            <p>针对印刷包装行业的VOCs排放特点，提供定制化的监测与治理解决方案</p>
          </div>
          <div class="industry-card">
            <div class="industry-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 8V16" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 12H16" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>制药行业</h3>
            <p>为制药企业提供符合GMP标准的VOCs治理和LDAR检测服务</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 数据化实力 -->
    <section class="partners">
      <div class="container">
        <h2>数据化实力</h2>
        <div class="stats-grid">
          <div v-for="(stat, index) in stats" :key="index" class="stat-item">
            <div class="stat-number">{{ stat.placeholder || (stat.current + '+') }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'AppHome',
  data() {
    return {
      currentSlide: 0,
      slides: 2,
      mouseX: 0,
      maskPosition: 50,
      titleText: '绿色智控 · 精准减排',
      subtitleText: '专注VOCs治理与LDAR技术服务，助力企业绿色高效发展',
      stats: [
        { value: 2000, label: '服务企业', current: 0 },
        { value: 2000, label: '完成项目', current: 0 },
        { value: 6, label: '覆盖行业大类', current: 0 },
        { value: 40, label: '软著权', current: 0 },
        { value: 100, label: '专业团队', current: 0 }
      ],
      isStatsAnimating: false
    }
  },
  mounted() {
    // 自动轮播 - 间隔5秒
    this.slideInterval = setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % this.slides;
      // 实现轮播效果，切换图片的显示/隐藏
      const img1 = document.querySelector('.hero-image-1');
      const img2 = document.querySelector('.hero-image-2');
      
      if (img1 && img2) {
        if (this.currentSlide === 0) {
          img1.style.opacity = '0.9';
          img2.style.opacity = '0';
        } else {
          img1.style.opacity = '0';
          img2.style.opacity = '0.9';
        }
      }
    }, 5000);

    // 鼠标移动事件
    this.handleMouseMove = (e) => {
      // 获取鼠标在窗口中的位置
      this.mouseX = e.clientX;
      // 计算遮罩位置 (0-100)
      const windowWidth = window.innerWidth;
      this.maskPosition = (this.mouseX / windowWidth) * 100;

      // 更新图片位置
      this.updateImagePositions();
    };

    // 监听鼠标移动
    window.addEventListener('mousemove', this.handleMouseMove);

    // 监听滚动，触发数据动画
    this.observeStats();
  },
  methods: {
    updateImagePositions() {
      // 获取图片和遮罩元素
      const img1 = document.querySelector('.hero-image-1');
      const mask = document.querySelector('.hero-mask');
      const overlay = document.querySelector('.hero-overlay');

      if (img1 && mask && overlay) {
        // 移动底图 (反向移动以创造视差效果)
        const moveX1 = (this.maskPosition - 50) * 0.05;
        img1.style.transform = `translateX(${moveX1}%)`;

        // 移动遮罩图片 (同向移动以创造不同的视差效果)
        const moveXMask = (50 - this.maskPosition) * 0.03;
        mask.style.transform = `translateX(${moveXMask}%)`;

        // 更新叠加层位置
        overlay.style.width = `${this.maskPosition}%`;
      }

      // 更新文字颜色
      this.updateTextColor();
    },

    updateTextColor() {
      // 获取遮罩层和文字元素
      const overlay = document.querySelector('.hero-overlay');
      const titleSpans = document.querySelectorAll('.hero-title span');
      const subtitleSpans = document.querySelectorAll('.hero-subtitle span');

      if (!overlay) return;

      // 使用getBoundingClientRect获取精确位置
      const overlayRect = overlay.getBoundingClientRect();
      const overlayRight = overlayRect.right;

      // 检查每个文字是否被遮罩覆盖
      [...titleSpans, ...subtitleSpans].forEach(span => {
        const spanRect = span.getBoundingClientRect();
        const spanLeft = spanRect.left;
        const spanRight = spanRect.right;

        // 计算文字元素中心位置
        const spanCenter = (spanLeft + spanRight) / 2;

        // 当文字中心位置小于遮罩层右侧边缘时，改变颜色
        // 添加一个小的偏移量(5px)以提高同步精度
        if (spanCenter < overlayRight + 5) {
          span.classList.add('masked');
        } else {
          span.classList.remove('masked');
        }
      });
    },
    observeStats() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isStatsAnimating) {
            this.isStatsAnimating = true;
            this.animateStats();
          }
        });
      }, {
        threshold: 0.1
      });

      const statsSection = document.querySelector('.partners');
      if (statsSection) {
        observer.observe(statsSection);
      }
    },
    animateStats() {
      this.stats.forEach((stat, index) => {
        if (stat.placeholder) return;
        
        const duration = 2000; // 动画持续时间
        const startTime = Date.now();
        const startValue = 0;
        const endValue = stat.value;

        const animate = () => {
          const elapsed = Date.now() - startTime;
          const progress = Math.min(elapsed / duration, 1);
          
          // 使用缓动函数
          const easeOutQuad = 1 - (1 - progress) * (1 - progress);
          stat.current = Math.floor(startValue + (endValue - startValue) * easeOutQuad);

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            stat.current = endValue;
          }
        };

        // 为每个统计项添加延迟，创造层次感
        setTimeout(animate, index * 200);
      });
    }
  },
  beforeUnmount() {
    clearInterval(this.slideInterval);
    // 移除鼠标移动监听
    window.removeEventListener('mousemove', this.handleMouseMove);
  }
}
</script>

<style scoped>
.hero {
  position: relative;
  padding: 0;
  text-align: center;
  height: 100vh;
  min-height: 600px;
  overflow: hidden;
}

.hero-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.hero-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: transform 0.5s ease-out;
}

.hero-image-1 {
  background-image: url('../assets/banner.jpg');
  z-index: 0;
  opacity: 0.9;
}

/* 轮播图片样式 */
.hero-image-2 {
  background-image: url('../assets/banner.jpg');
  z-index: 0;
  opacity: 0;
  transition: opacity 1s ease;
}

.hero-mask {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-image: url('../assets/banner.jpg');
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 2;
  transition: width 0.3s ease-out;
  width: 50%;
}

.hero-content {
  position: relative;
  z-index: 3;
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}

.hero-title {
  font-size: 56px;
  font-weight: 700;
  margin-bottom: 25px;
  color: #fff;
  line-height: 1.2;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  letter-spacing: -0.5px;
}

.hero-subtitle {
    font-size: 22px;
    margin-bottom: 40px;
    color: rgba(255, 255, 255, 0.9);
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.6;
  }

  .hero-title span,
  .hero-subtitle span {
    transition: color 0.3s ease;
    display: inline-block;
  }

  .hero-title span.masked,
  .hero-subtitle span.masked {
    color: #42b983; /* 遮罩覆盖时的颜色 */
    text-shadow: 0 0 8px rgba(66, 185, 131, 0.6);
  }

@media screen and (max-width: 768px) {
  .hero {
    padding: 120px 0 100px;
  }

  .hero-title {
    font-size: 42px;
  }

  .hero-subtitle {
    font-size: 19px;
  }

  .btn-primary {
    padding: 12px 30px;
  }
}

@media screen and (max-width: 480px) {
  .hero {
    padding: 100px 0 80px;
  }

  .hero-title {
    font-size: 32px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .btn-primary {
    padding: 12px 28px;
    font-size: 14px;
  }
}

.btn-primary {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 14px 36px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(66, 185, 131, 0.3);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.btn-primary:hover {
  background-color: #3aa876;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(66, 185, 131, 0.4);
}

.hero-btn {
  margin-top: 15px;
}

.features {
  padding: 80px 0;
  background-color: #f9f9f9;
  background-image: 
    linear-gradient(rgba(0, 0, 0, 0.01) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 0, 0, 0.01) 1px, transparent 1px),
    linear-gradient(45deg, rgba(66, 185, 131, 0.01) 1px, transparent 1px),
    linear-gradient(135deg, rgba(66, 185, 131, 0.01) 1px, transparent 1px),
    radial-gradient(circle at 25% 25%, rgba(66, 185, 131, 0.005) 0%, transparent 50%),
    radial-gradient(circle at 75% 75%, rgba(66, 185, 131, 0.005) 0%, transparent 50%);
  background-size: 50px 50px, 50px 50px, 100px 100px, 100px 100px, 200px 200px, 200px 200px;
  background-position: -1px -1px, -1px -1px, -2px -2px, -2px -2px, 0 0, 0 0;
}

.features h2 {
  text-align: center;
  font-size: 36px;
  margin-bottom: 50px;
  color: #333;
}

.feature-cards {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.feature-card {
  flex: 1;
  min-width: 280px;
  padding: 30px;
  margin: 0 15px 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

@media screen and (max-width: 768px) {
  .features h2 {
    font-size: 28px;
  }

  .feature-card {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .features h2 {
    font-size: 24px;
  }

  .feature-card {
    padding: 20px;
    margin: 0 10px 20px;
  }

  .feature-card h3 {
    font-size: 18px;
  }

  .feature-card p {
    font-size: 14px;
  }
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.icon {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.feature-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
  text-align: center;
}

.feature-card p {
  color: #666;
  line-height: 1.6;
  text-align: center;
}

/* 解决方案体系 */
.solutions {
  padding: 80px 0;
  background-color: #fff;
}

.solutions h2 {
  text-align: center;
  font-size: 36px;
  margin-bottom: 50px;
  color: #333;
}

.solution-cards {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.solution-card {
  flex: 1;
  min-width: 280px;
  padding: 30px;
  margin: 0 15px 30px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
}

.solution-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  background-color: #f0f8f5;
}

.solution-icon {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.solution-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
  text-align: center;
}

.solution-card {
  text-decoration: none !important;
}

.solution-card:hover {
  text-decoration: none !important;
}

.solution-card p {
  color: #666;
  line-height: 1.6;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .solutions h2 {
    font-size: 28px;
  }

  .solution-card {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .solutions h2 {
    font-size: 24px;
  }

  .solution-card {
    padding: 20px;
    margin: 0 10px 20px;
  }

  .solution-card h3 {
    font-size: 18px;
  }

  .solution-card p {
    font-size: 14px;
  }
}

/* 行业解决方案 */
.industry-solutions {
  padding: 80px 0;
  background-color: #f9f9f9;
  background-image: 
    linear-gradient(rgba(0, 0, 0, 0.01) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 0, 0, 0.01) 1px, transparent 1px),
    linear-gradient(45deg, rgba(66, 185, 131, 0.01) 1px, transparent 1px),
    linear-gradient(135deg, rgba(66, 185, 131, 0.01) 1px, transparent 1px),
    radial-gradient(circle at 25% 25%, rgba(66, 185, 131, 0.005) 0%, transparent 50%),
    radial-gradient(circle at 75% 75%, rgba(66, 185, 131, 0.005) 0%, transparent 50%);
  background-size: 50px 50px, 50px 50px, 100px 100px, 100px 100px, 200px 200px, 200px 200px;
  background-position: -1px -1px, -1px -1px, -2px -2px, -2px -2px, 0 0, 0 0;
}

.industry-solutions h2 {
  text-align: center;
  font-size: 36px;
  margin-bottom: 50px;
  color: #333;
}

.industry-cards {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.industry-card {
  flex: 1;
  min-width: 280px;
  padding: 30px;
  margin: 0 15px 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
}

.industry-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  background-color: #f0f8f5;
}

.industry-icon {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.industry-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
  text-align: center;
}

.industry-card p {
  color: #666;
  line-height: 1.6;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .industry-solutions h2 {
    font-size: 28px;
  }

  .industry-card {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .industry-solutions h2 {
    font-size: 24px;
  }

  .industry-card {
    padding: 20px;
    margin: 0 10px 20px;
  }

  .industry-card h3 {
    font-size: 18px;
  }

  .industry-card p {
    font-size: 14px;
  }
}

/* 数据化实力 */
.partners {
  padding: 80px 0;
  background-color: #f9f9f9;
  background-image: 
    linear-gradient(rgba(0, 0, 0, 0.01) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 0, 0, 0.01) 1px, transparent 1px),
    linear-gradient(45deg, rgba(66, 185, 131, 0.01) 1px, transparent 1px),
    linear-gradient(135deg, rgba(66, 185, 131, 0.01) 1px, transparent 1px),
    radial-gradient(circle at 25% 25%, rgba(66, 185, 131, 0.005) 0%, transparent 50%),
    radial-gradient(circle at 75% 75%, rgba(66, 185, 131, 0.005) 0%, transparent 50%);
  background-size: 50px 50px, 50px 50px, 100px 100px, 100px 100px, 200px 200px, 200px 200px;
  background-position: -1px -1px, -1px -1px, -2px -2px, -2px -2px, 0 0, 0 0;
}

.partners h2 {
  text-align: center;
  font-size: 36px;
  margin-bottom: 50px;
  color: #333;
}

.stats-grid {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 40px;
}

.stat-item {
  text-align: center;
  padding: 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  min-width: 220px;
  max-width: 260px;
}

.stat-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.stat-number {
  font-size: 56px;
  font-weight: 700;
  margin-bottom: 10px;
  line-height: 1;
}

.stat-item:nth-child(1) .stat-number {
  color: #42b983;
}

.stat-item:nth-child(2) .stat-number {
  color: #3498db;
}

.stat-item:nth-child(3) .stat-number {
  color: #9b59b6;
}

.stat-item:nth-child(4) .stat-number {
  color: #e74c3c;
}

.stat-item:nth-child(5) .stat-number {
  color: #f39c12;
}

.stat-label {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}

@media screen and (max-width: 768px) {
  .partners h2 {
    font-size: 28px;
  }

  .stats-grid {
    gap: 30px;
  }

  .stat-item {
    min-width: 150px;
    max-width: 180px;
    padding: 25px;
  }

  .stat-number {
    font-size: 36px;
  }

  .stat-label {
    font-size: 14px;
  }
}

@media screen and (max-width: 480px) {
  .partners h2 {
    font-size: 24px;
  }

  .stats-grid {
    gap: 20px;
  }

  .stat-item {
    min-width: 120px;
    max-width: 140px;
    padding: 20px;
  }

  .stat-number {
    font-size: 28px;
  }

  .stat-label {
    font-size: 12px;
  }
}

</style>